
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import TextAreaField from 'components/formFields/TextAreaField';
import { storeItemsStore } from 'store/size_items';
import AutocompleteField from 'components/formFields/autocompleteField';


export const EditDinamicDotacion = ({ children }: any) => {

  const dispatch = useDispatch();
  const formikProps: any = useFormikContext();

  // REDUX 
  const { sizeItemsDotacion }: any = useSelector((state: any) => state.sizeItems);

  const dotacionList = [
    { label: 'bata mantenimiento', value: 'bata_mantenimiento' },
    { label: 'blazer', value: 'blazer' },
    { label: 'blusa', value: 'blusa' },
    { label: 'botas', value: 'botas' },
    { label: 'bufanda', value: 'bufanda' },
    { label: 'camisa', value: 'camisa' },
    { label: 'chaqueta impermeable', value: 'chaqueta_impermeable' },
    { label: 'corbata', value: 'corbata' },
    { label: 'delantal', value: 'delantal' },
    { label: 'falda short', value: 'falda_short' },
    { label: 'grillo', value: 'grillo' },
    { label: 'jean', value: 'jean' },
    { label: 'pantalon', value: 'pantalon' },
    { label: 'zapatos', value: 'zapatos' },
  ];

 
  
 

  const removeItem = async (index: number) => {
    const items = formikProps.values.items;
    if (Array.isArray(items) && index >= 0 && index < items.length) {
      const updatedItems = [...items];
      updatedItems.splice(index, 1);
      formikProps.setFieldValue('items', updatedItems);
      await dispatch(storeItemsStore(updatedItems));
    }
  };

  



  const handleItemChange = (index: number, field: string, value: any) => {
    // Usamos JSON.parse y JSON.stringify para crear una copia profunda y evitar errores de solo lectura.
    const currentItems = JSON.parse(JSON.stringify(formikProps.values.items || []));
 
    currentItems[index][field] = value; // Modificamos la copia.
 
    formikProps.setFieldValue('items', currentItems); // Actualizamos Formik con la copia modificada.
  };

  return (
    <>
      {children.map((_: any, index: number) => (
        <Paper
            elevation={3}
            sx={{
                p: 5,
                mb: 4,
                borderRadius: 3,
                backgroundColor: '#fdfdfd',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            }}
            key={index}
            >
            <Grid container justifyContent="space-between" alignItems="center">
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Dotación {index + 1}
                </Typography>
                <Tooltip title="Eliminar item" arrow>
                <IconButton color="error" onClick={() => removeItem(index)}>
                    <DeleteIcon />
                </IconButton>
                </Tooltip>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: 10 }}>
                <Grid size={{ xs: 2 }}>
                <AutocompleteField
                    options={dotacionList}
                    name={`items[${index}].nombre`}
                    label={'Item'}
                    element={`items[${index}].nombre`}
                    required
                    onChange={(e: any, value: any) => handleItemChange(index, 'nombre', value)}
                />
                </Grid>
                <Grid size={{ xs: 2 }}>
                <InputField
                    name={`items[${index}].talla`}
                    label={'Talla'}
                    fullWidth
                    required
                    onChange={(e:any) => handleItemChange(index, 'talla', e.target.value)}
                />
                </Grid>
                <Grid size={{ xs: 2 }}>
                <InputNumeric
                    name={`items[${index}].cantidad`}
                    label={'Cantidad'}
                    fullWidth
                    required
                    onChange={(e:any) => handleItemChange(index, 'cantidad', e.target.value)}
                />
                </Grid>
                <Grid size={{ xs: 2 }}>
                <InputField
                    name={`items[${index}].color`}
                    label={'Color'}
                    fullWidth
                    required
                    onChange={(e:any) => handleItemChange(index, 'color', e.target.value)}
                />
                </Grid>
                <Grid size={{ xs: 4 }}>
                <TextAreaField
                    name={`items[${index}].descripcion`}
                    label={'Descripción'}
                    fullWidth
                    required
                    onChange={(e:any) => handleItemChange(index, 'descripcion', e.target.value)}
                />
                </Grid>
            </Grid>
            </Paper>

      ))}
    </>
  );
};